// extracted by mini-css-extract-plugin
export var img = "EmbeddedEntries-module--img--99b43";
export var media = "EmbeddedEntries-module--media--3f1de";